import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";

import img1 from "../assets/industrialnets/1.jpg";
import img2 from "../assets/industrialnets/2.jpg";
import img3 from "../assets/industrialnets/3.jpg";
import main from "../assets/industrialnets/main.jpg";
import Images from "./Images";
import { Helmet } from "react-helmet-async";

export default function IndustrialSafetyNets() {

       useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Industrial safety nets/construction safety net banglore",
    url: "https://www.anssafetynets.com/industrialsafetynets",
    description:
      "Industrial Safety Nets – Reliable Fall Protection for WorksitesOur industrial safety nets are designed to provide maximum protection for workers and equipment in high-risk environments such as construction sites, warehouses, shipyards, and manufacturing plants. Made from high-tensile, UV-resistant materials, these nets ensure durability, strength, and long-term performance under extreme conditions.S",
    keywords: [
  "construction safety netting",
  "industrial fall arrest nets",
  "warehouse safety nets",
  "scaffolding safety nets",
  "custom industrial nets",
  "OSHA compliant safety nets",
  "debris control industrial safety nets",
  "safety nets for construction",
  "fall protection nets",
  "worksite safety nets",
  "heavy-duty safety nets",
  "where to buy heavy-duty safety nets online",
  "fall protection net systems for buildings",
  "safety net installation for factories",
  "custom size industrial safety nets near me",
  "best industrial safety nets for construction sites",
  "industrial safety nets in Bangalore",
  "construction net suppliers near me",
  "safety net installers in Bengaluru"
],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Industrial Safety Nets",
          item: "https://www.anssafetynets.com/industrialsafetynets",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Industrial Safety Nets",
          areaServed: "Bengaluru",
        },
      ],
    },
  };
  return (
    <div>
      <Helmet>
        <title>Industrial safety nets/construction safety net banglore</title>
        <meta
          name="description"
          content="Industrial Safety Nets – Reliable Fall Protection for Worksites
Our industrial safety nets are designed to provide maximum protection for workers and
equipment in high-risk environments such as construction sites, warehouses, shipyards,
and manufacturing plants. Made from high-tensile, UV-resistant materials, these nets
ensure durability, strength, and long-term performance under extreme conditions.S"
        />
        <meta
          name="keywords"
          content="Construction safety netting
Industrial fall arrest nets
Warehouse safety nets
Scaffolding safety nets
Custom industrial nets
OSHA compliant safety nets
Debris contIndustrial safety nets
Safety nets for construction
Fall protection nets
Worksite safety nets
Heavy-duty safety nets
Where to buy heavy-duty safety nets online
Fall protection net systems for buildings
Safety net installation for factories
Custom size industrial safety nets near me
Best industrial safety nets for construction sites
Industrial safety nets in Bangalore 
 construction net suppliers near me 
Safety net installers in Bengaluru "
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link
          rel="canonical"
          href="https://www.anssafetynets.com/industrialsafetynets"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <HeroSection
        title="Industrial Safety Nets"
        description="Safety nets designed for industrial applications to protect workers and equipment."
        bgColor="bg-[#2c3639]"
      />

      <ProductDetails
        title="Why Choose Our Industrial Safety Nets?"
        content="At ANS Safety Nets, we provide industrial safety nets that are built to withstand the toughest working conditions. Made from high-strength, durable materials, our nets offer superior protection, ensuring safety for workers in hazardous environments. Whether you're working on construction sites, factories, or other industrial settings, our safety nets are designed to handle heavy-duty tasks and resist wear and tear from harsh weather conditions. Engineered for reliability and longevity, our industrial safety nets help prevent accidents, keep equipment secure, and ensure a safer work environment. Trust ANS Safety Nets to provide the highest level of safety for your workforce."
        image={main}
      />
      <Images images={[img1, img2, img3]} />

      <Benefits
        benefits={[
          {
            title: "Worker Protection",
            description:
              "Keep your workforce safe from accidental falls in high-risk areas.",
          },
          {
            title: "Heavy Duty",
            description:
              "Built to handle the toughest industrial environments.",
          },
          {
            title: "Cost-Effective",
            description:
              "Affordable solutions to protect your personnel and reduce liability.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question: "Are these nets fire-resistant?",
            answer:
              "Yes, they are made with fire-resistant materials for additional safety.",
          },
          {
            question: "Do the nets come in different sizes?",
            answer: "Yes, we offer custom sizes to fit your requirements.",
          },
        ]}
      />
    </div>
  );
}
